import React from 'react';

import useRestrictionsSingle from './useRestrictionsSingle';

interface Props {
    betslipBetId: string;
    betslipOddId: string;
}

const RestrictionsSingle: React.FC<Props> = ({
    betslipBetId,
    betslipOddId,
}) => {
    useRestrictionsSingle({ betslipBetId, betslipOddId });

    return null;
};

export default React.memo(RestrictionsSingle);
